import React from 'react';

// Hue goes from fog (no retention) toward canopy (full retention).
function cellColor(rate) {
  if (rate == null) return { background: '#F7F4EF', color: '#B8B2A8' };
  const pct = Math.max(0, Math.min(1, rate));
  const alpha = 0.12 + pct * 0.75;
  const textColor = pct > 0.5 ? '#ffffff' : '#1E2328';
  return {
    background: `rgba(27, 107, 74, ${alpha.toFixed(2)})`,
    color: textColor,
  };
}

const RetentionHeatmap = ({ cohorts }) => {
  const rows = (cohorts || []).slice(-12); // last 12 weeks
  if (rows.length === 0) {
    return (
      <div className="card p-6">
        <h3 className="font-bold text-ink-900 text-[0.9375rem] mb-1">Cohort retention</h3>
        <p className="text-xs text-ink-400 mb-5">W1 and W4 retention by signup week.</p>
        <div className="h-32 flex items-center justify-center text-sm text-ink-400">
          No cohort data yet — daily rollup populates this.
        </div>
      </div>
    );
  }

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-bold text-ink-900 text-[0.9375rem]">Cohort retention</h3>
        <span className="text-xs text-ink-400">Last 12 signup weeks</span>
      </div>
      <p className="text-xs text-ink-400 mb-5">
        % of users who signed up in week N and were active in week N+1 / N+4.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm tabular-nums">
          <thead>
            <tr className="text-xs font-semibold text-ink-500 border-b border-surface-100">
              <th className="text-left pb-2 pr-4 font-semibold">Signup week</th>
              <th className="text-right pb-2 pr-3 font-semibold">Signups</th>
              <th className="text-center pb-2 font-semibold">W1</th>
              <th className="text-center pb-2 font-semibold">W4</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => {
              const w1 = c.signupCount ? (c.retainedWeek1 || 0) / c.signupCount : null;
              const w4 = c.signupCount ? (c.retainedWeek4 || 0) / c.signupCount : null;
              return (
                <tr key={c.id} className="border-b border-surface-100/60">
                  <td className="py-2 pr-4 font-medium text-ink-700">{c.id}</td>
                  <td className="py-2 pr-3 text-right text-ink-500">{c.signupCount || 0}</td>
                  <td className="py-2 px-1">
                    <div
                      className="rounded-lg py-1 text-center text-xs font-semibold"
                      style={cellColor(w1)}
                    >
                      {w1 == null ? '—' : `${Math.round(w1 * 100)}%`}
                    </div>
                  </td>
                  <td className="py-2 px-1">
                    <div
                      className="rounded-lg py-1 text-center text-xs font-semibold"
                      style={cellColor(w4)}
                    >
                      {w4 == null ? '—' : `${Math.round(w4 * 100)}%`}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RetentionHeatmap;
